import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNotFound: false,
  // add other state fields if needed
};

const pageNotFoundSlice = createSlice({
  name: "pageNotFound",
  initialState,
  reducers: {
    setIsNotFound(state, action) {
      state.isNotFound = action.payload;
    },
    // add other reducers here if needed
  },
});

export const { setIsNotFound } = pageNotFoundSlice.actions;

export default pageNotFoundSlice.reducer;
